// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"11855a28","963":"25ce80a2"}[chunkId] + ".chunk.css";
};